import { api } from '@connected/api-client';
import { useParams } from '@tanstack/react-router';
import { useMemo } from 'react';
import { toast } from 'sonner';

import { useOffline } from '@/stores/network-status';

export function useGenerateInspectionPlan() {
    const params = useParams({ from: '/(auth)/projects/$projectVersionId' });
    const isOffline = useOffline();

    const mutation = api.useMutation(
        'post',
        '/api/v2/electrical/projects/documents/create',
        {
            // TODO: Add translation
            onSuccess: () => toast.success('Inspectieplan wordt aan de wachtrij toegevoegd'),
            // TODO: Add translation
            onError: () => toast.error('Er is een fout opgetreden bij het genereren van het inspectieplan'),
        },
    );

    function handleGenerateInspectionPlan() {
        if (isOffline) {
            toast.error('Je bent offline, probeer het later opnieuw.');
            return;
        }

        return mutation.mutate({
            body: {
                ElectricalProjectVersionId: params.projectVersionId,
                Kind: 'InspectionPlan',
            },
        });
    }

    const disabled = useMemo(() => {
        return mutation.isPending || isOffline;
    }, [mutation.isPending, isOffline]);

    return {
        handleGenerateInspectionPlan,
        disabled,
        ...mutation,
    };
}
